import { NetworkStatus } from "@apollo/client";
import { useParams } from "react-router-dom";

import { PollingIntervalGroups } from "apollo/constants";
import usePolledQuery from "apollo/usePolledQuery";
import { VcsIntegration } from "types/generated";

import { getVcsProviderByUrlKey } from "../VcsShared/helpers";
import { GET_VCS_INTEGRATION } from "./gql";

export const useVCSIntegration = () => {
  const { integrationId: id, integrationGroup: rawProvider } = useParams<{
    integrationGroup: string;
    integrationId: string;
  }>();
  const provider = getVcsProviderByUrlKey(rawProvider);

  const { data, loading, error, networkStatus } = usePolledQuery<{
    vcsIntegration: VcsIntegration;
  }>(GET_VCS_INTEGRATION, {
    variables: {
      id,
      provider,
      searchUsersSuggestionsInput: {
        fields: null,
        fullTextSearch: null,
        predicates: null,
      },
    },
    pollingGroup: PollingIntervalGroups.Lists,
    // avoid request executing twice while fetchMore
    nextFetchPolicy: "cache-first",
    skip: !provider || !id,
  });

  const totalEntitiesCount = data?.vcsIntegration?.searchUsersSuggestions?.filteredCount || 0;

  return {
    integration: data?.vcsIntegration || null,
    error,
    isPageLoading: loading && !data?.vcsIntegration && networkStatus === NetworkStatus.loading,
    isPageRefetching: loading && networkStatus !== NetworkStatus.loading,
    totalEntitiesCount,
    loading,
  };
};
